import { classNames } from "@/utils/classNames";
import { Popover as BasePopover } from "@base-ui/react/popover";
import { ReactElement, useEffect, useRef, useState } from "react";

export type PopoverProps = {
  button: ReactElement;
  content: ((params: { close: () => void }) => ReactElement) | ReactElement;
  bg?: "dark";
  initiallyOpen?: boolean;
};

export function Popover(props: PopoverProps) {
  const actionsRef = useRef<BasePopover.Root.Actions | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.initiallyOpen) {
      const timeoutId = setTimeout(() => setOpen(true), 500);
      return () => clearTimeout(timeoutId);
    }
  }, [props.initiallyOpen]);

  return (
    <BasePopover.Root actionsRef={actionsRef} open={open} onOpenChange={(open) => setOpen(open)}>
      <BasePopover.Trigger render={props.button} />
      <BasePopover.Portal>
        <BasePopover.Positioner>
          <BasePopover.Popup
            className={classNames(
              props.bg === "dark"
                ? "bg-gray-x-hard color-primary-contrast"
                : "bg-default color-default border border-gray-soft",
              "rounded-sm",
              "shadow-lg",
              "p-4",
              "data-starting-style:opacity-0",
              "data-ending-style:opacity-0",
              "transition",
              "duration-200",
            )}
          >
            {typeof props.content === "function"
              ? props.content({ close: () => actionsRef.current?.close() })
              : props.content}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
